"use client";
import { Button } from "@/components/ui/button";
import {
  ChevronLeft,
  ChevronRight,
  Facebook,
  Instagram,
  Twitter,
  Youtube,
} from "lucide-react";
import Link from "next/link";
import Image from "next/image";

export function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <footer className="bg-foreground text-primary relative overflow-hidden">
      {/* Background texture overlay */}
      <div className="absolute inset-0 bg-muted-secondary" />

      <div className="relative z-10">
        {/* Top section with logo and social icons */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-16">
            <button
              type="button"
              onClick={() => scrollToSection("home")}
              className="flex items-center gap-2 focus-visible:outline-none"
              aria-label="Go to home"
            >
              <Image
                src="/images/magic-wok-logo-horizontal.jpeg"
                alt="Magic Wok logo"
                width={300}
                height={48}
                priority
              />
            </button>
          </div>

          {/* Main footer content */}
          <div className="grid md:grid-cols-3 gap-12 mb-16">
            {/* About us */}
            <div>
              <h3 className="text-xl font-bold mb-6">Magic Wok</h3>
              <p className="text-gray-400 leading-relaxed mb-8">
                Este locul ideal pentru cei care vor să descopere adevărata
                bucătărie chineză autentică, departe de adaptările occidentale,
                într-o atmosferă ce îmbină tradiția cu rafinamentul modern.
              </p>
              <Button
                className="px-6 py-2 font-medium bg-primary text-primary-foreground hover:bg-primary/90 "
                onClick={() => scrollToSection("menu")}
              >
                MENIU
              </Button>
            </div>

            {/* Contact info */}
            <div>
              <h3 className="text-xl font-bold mb-6 ">Informații de contact</h3>
              <div className="space-y-4 mb-8">
                <div>
                  <span className="text-gray-400 text-sm">TELEFON: </span>
                  <p>0758 668 866</p>
                </div>
                <div>
                  <span className="text-gray-400 text-sm">EMAIL: </span>
                  <p>office@magicwok.ro</p>
                </div>
                <div>
                  <span className="text-gray-400 text-sm">ADRESĂ: </span>
                  <p style={{ color: "#f1efe8" }}>
                    Strada Elena Caragiani nr. 33, Sector 1, Bucuresti
                  </p>
                </div>
              </div>
            </div>

            {/* Gallery */}
            <div>
              <div className="h-80 flex flex-col gap-4">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2846.534615224629!2d26.095808299999995!3d44.483711299999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b203594dab8a2d%3A0x20d59b9f9644cc9e!2sMagic%20Wok!5e0!3m2!1sen!2sro!4v1756557977436!5m2!1sen!2sro"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Magic Wok Location"
                />
              </div>
            </div>
          </div>

          {/* Bottom section */}
          <div className="border-t border-gray-700 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="flex flex-row gap-4">
                <p className="text-gray-400 text-sm mb-4 md:mb-0">
                  © {new Date().getFullYear()} Magic Wok. Toate drepturile
                  rezervate.
                </p>
                <Link
                  href="/termeni-si-conditii"
                  className="text-gray-400 text-sm mb-4 md:mb-0"
                >
                  Termeni și condiții
                </Link>
              </div>

              <Button onClick={() => scrollToSection("home")}>
                ÎNAPOI LA ÎNCEPUT
              </Button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
